import * as React from "react";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { ChevronDown } from "lucide-react";

import { cn } from "utils";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <CollapsiblePrimitive.Trigger
      ref={ref}
      className={cn(
        "group w-full rounded-md px-3 py-2 text-left transition-colors",
        "hover:bg-accent hover:text-accent-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        "disabled:pointer-events-none disabled:opacity-50",
        className
      )}
      {...props}
    >
      <div className="flex flex-col gap-0.5">{children}</div>
    </CollapsiblePrimitive.Trigger>
  )
);
CollapsibleTrigger.displayName = CollapsiblePrimitive.Trigger.displayName;

const CollapsibleLabel = ({ className, children, ...props }) => (
  <div
    className={cn(
      "flex items-center gap-2 text-sm font-medium leading-none",
      className
    )}
    {...props}
  >
    <span className="min-w-0 truncate">{children}</span>

    <ChevronDown className="h-4 w-4 shrink-0 transition-transform group-data-[state=open]:rotate-180" />
  </div>
);
CollapsibleLabel.displayName = "CollapsibleLabel";

const CollapsibleSubLabel = ({ className, ...props }) => (
  <div className={cn("text-xs text-muted-foreground", className)} {...props} />
);
CollapsibleSubLabel.displayName = "CollapsibleSubLabel";

const CollapsibleContent = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <CollapsiblePrimitive.Content
      ref={ref}
      className={cn(
        "overflow-hidden text-sm text-muted-foreground",
        "data-[state=open]:animate-collapsible-down data-[state=closed]:animate-collapsible-up",
        className
      )}
      {...props}
    >
      <div className="border-t" />
      <div className="px-3 pb-3 pt-2">{children}</div>
    </CollapsiblePrimitive.Content>
  )
);
CollapsibleContent.displayName = CollapsiblePrimitive.Content.displayName;

export {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
  CollapsibleLabel,
  CollapsibleSubLabel,
};
